









































import Vue from 'vue'

export default Vue.extend({
  name: 'PhilosophyInfo',
  data: () => ({
    philospohyText:
      'Innovativeでありたいと思う人が、本当にやりたいことを見つけられ、\n本当にやりたいことを実現できるよう、ここにInnovatorの輪を広げ、\nInnovationの芽を育み、Innovatorが心から自由に輝ける場を実現する'
  })
})
